const queryParams = new URLSearchParams(window.location.search);
const isStaging = queryParams.get("staging");

export const API_URL = isStaging ? "https://dev-api.mymedcal.com" : "https://api.mymedcal.com";
